import type { ReactElement } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { ButtonPreset } from '@/constants/componentPresets';
import { Cbutton } from '../Cbutton';
import { Ctext } from '../Ctext';
interface InitialAuthFooterProps {
    onOpenTerms: () => void;
    onPrivacyClick: () => void;
}
export function InitialAuthFooter({ onOpenTerms, onPrivacyClick }: InitialAuthFooterProps): ReactElement {
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '5px',
            marginTop: '13px',
        }}>
        <Ctext size={16} weight={FontWeight.Regular} color={ColorType.White} opacity={1} style={{ textAlign: 'center' }}>
          By continuing, you accept the protocol.
        </Ctext>

        <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '16px',
        }}>
          <Cbutton preset={ButtonPreset.Ghost} ariaLabel="Open terms" padding={0} disableHoverEffects style={{ cursor: 'pointer' }} onClick={onOpenTerms}>
            <Ctext size={16} weight={FontWeight.Medium} color={ColorType.Accent} opacity={1}>
              [ Terms ]
            </Ctext>
          </Cbutton>
          <Ctext size={9.6} weight={FontWeight.Regular} color={ColorType.Accent} opacity={1}>
            •
          </Ctext>
          <Cbutton preset={ButtonPreset.Ghost} ariaLabel="Open privacy policy" padding={0} disableHoverEffects style={{ cursor: 'pointer' }} onClick={onPrivacyClick}>
            <Ctext size={16} weight={FontWeight.Medium} color={ColorType.Accent} opacity={1}>
              [ Privacy ]
            </Ctext>
          </Cbutton>
        </div>
      </div>
    );
}
